export enum PaymentSourceTypeEnum {
    Reward = 1,
    Store = 2,
    Card = 3,
    Flex = 4,
}
